export default {
  initializeDaisyChain(state, details) {
    const { pageKind, baseUrl, repeatedAction, thanksMessageKey, successMessageKey, previousStepKind } = details
    state.pageKind = pageKind
    state.baseUrl = baseUrl
    state.repeatedAction = repeatedAction
    state.thanksMessageKey = thanksMessageKey
    state.successMessageKey = successMessageKey
    state.previousStepKind = previousStepKind
  },

  setCurrentStep(state, { kind, data, hasNextStep, stepsProgress, tracking }) {
    state.currentStepKind = kind
    state.stepData = data
    state.hasNextStep = hasNextStep
    state.stepsProgress = stepsProgress
    state.stepTrackingData = tracking
  }
}
